var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"contnet"},[_c('el-header',{staticStyle:{"padding":"0"}},[_c('MenuVue')],1),_vm._v(" "),_c('el-main',{staticStyle:{"width":"100vw","height":"calc(100vh - 60px)","padding":"0"}},[_c('RouterView',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c('KeepAlive',[_c(Component,{tag:"component"})],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bdcf1de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/index.vue
// module id = null
// module chunks = 